import React from 'react';

import { WanderingBoundarySettingsState } from 'features/wandering-boundary-settings/providers/states/wandering-boundary-settings-provider-state';

const WanderingBoundarySettingsProviderContext = React.createContext<WanderingBoundarySettingsState>({} as never);

export default WanderingBoundarySettingsProviderContext;
